import { render, staticRenderFns } from "./MaterialHelpModal.vue?vue&type=template&id=13d6ae3f&scoped=true&"
import script from "./MaterialHelpModal.vue?vue&type=script&lang=ts&"
export * from "./MaterialHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialHelpModal.vue?vue&type=style&index=0&id=13d6ae3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6ae3f",
  null
  
)

export default component.exports